import React from 'react'
import 'style/calling.css'
import { createNewMatrixCall } from 'matrix-js-sdk'
import Matrix from 'scripts/Matrix'
import CallEndIcon from '@material-ui/icons/CallEnd';

class Calling extends React.Component {
  constructor(props) {
    super(props)
    this.localVideo = React.createRef()
    this.remoteVideo = React.createRef()
    this.state = {
      client: this.props.client,
      roomId: this.props.roomId,
      open: false,
      matrixCall: null
    }
  }

  acceptCall = async (roomId, call) => {
    this.setState({ roomId })
    this.setState({ matrixCall: call })
    call.on('error', (data) => console.log('this is an error of call in calling component', data))
    call.on('hangup', () => this.close())
    await call.answer()
    call.setLocalVideoElement(this.localVideo.current)
    call.setRemoteVideoElement(this.remoteVideo.current)
  }

  show = async (isGlobal = false) => {
    console.log('show is callingggg----------------')
    await this.setState({ open: true })
    if (!isGlobal) await this.startVideoCall()
  }
  close = () => this.setState({ open: false })
  startVideoCall = async () => {

    const client = await Matrix.login()

    const matrixCall = createNewMatrixCall(client, this.state.roomId)

    this.setState({ matrixCall })

    matrixCall.on('error', (data) => console.log('this is error fo place video call ==========================================================', data))
    matrixCall.on('hangup', (call) => this.close())

    matrixCall.placeVideoCall(this.remoteVideo.current, this.localVideo.current)
    
    await this.props.notifyVideoCall()
  }

  endCall = () => {
    let hangUpReason = null
    console.log('end call by doctor', this.state.matrixCall)
    if (!this.state.matrixCall.didConnect) hangUpReason = 'not answered'
    if(this.state.matrixCall.state==='connected') 
      this.state.matrixCall.hangup(hangUpReason)
    else if(this.state.matrixCall.state==='ringing')  
      this.state.matrixCall.reject()
    this.close()
  }

  render() {
    return (
      this.state.open && 
        <div className="videoCallRoot">
          <div className="videoCallRoot__videoContainer">
            <video ref={this.remoteVideo} autoPlay playsInline className="videoCallRoot__videoContainer__videoRemote"/>
            <video ref={this.localVideo} autoPlay playsInline className="videoCallRoot__videoContainer__videoLocal"/>
          </div>
          <CallEndIcon className='videoCallRoot__endButton' onClick={this.endCall}/>
        </div>
    )
  }
}

export default Calling
